import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowPathRight"><Path d="M13 3.12451V7.99998H2V16H13V20.8754L23.4057 12L13 3.12451Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathRight;
